import styles from "./Employees.module.scss"
import Section from "../Section"
import Employee from "./Employee"

const EmployeesBlock = ({ data }) => {
  const {
    section_teaser,
    section_headline,
    section_subline,
    section_text,
    section_links,
    employees_block: employees,
  } = data

  return (
    <Section
      teaser={section_teaser}
      headline={section_headline}
      subline={section_subline}
      text={section_text}
      links={section_links}
    >
      <div className={styles.employees}>
        {!!employees.length > 0 &&
          employees.map((employee) => (
            <Employee key={employee.id} employee={employee} />
          ))}
      </div>
    </Section>
  )
}

export default EmployeesBlock
